import { Dialog, DialogTitle, DialogContent, IconButton } from '@mui/material';
import { Icons } from 'components';
import { useStylesOperationDialog } from './style';
export default function OperationDialog({ title, setOpen, open, children, onClose }) {
  const classes = useStylesOperationDialog();
  return (
    <Dialog
      onClose={() => {
        onClose ? onClose() : setOpen(false);
      }}
      aria-labelledby="simple-dialog-title"
      fullWidth
      maxWidth="sm"
      open={open}
      className={classes.dialogMain}
    >
      <DialogTitle
        id="customized-dialog-title"
        className={classes.title}
        onClose={() => (onClose ? onClose() : setOpen(false))}

      >
        {title}
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={() => setOpen(false)}
          size="large">
          <Icons icon='Close' color="#939393" size="20" />
        </IconButton>
      </DialogTitle>
      <DialogContent className={classes.dialog}>
        {children}
      </DialogContent>
    </Dialog>
  );
}
